import { render, staticRenderFns } from "./brandCustom.vue?vue&type=template&id=0162100e&"
import script from "./brandCustom.vue?vue&type=script&lang=js&"
export * from "./brandCustom.vue?vue&type=script&lang=js&"
import style0 from "./brandCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports